<template>
  <b-container fluid>
    <s-empty-list
      v-if="showEmptyList"
      :empty-message="$t('messages.MA076.message')"
      :loading="loading"
    />
    <div
      v-else
      class="oscillography-analysis"
    >
      <div class="oscillography-analysis__checkbox-area mb-2">
        <b-checkbox
          :checked="allDiagnosticsToggled"
          @change="toggleAllDiagnostics"
        />
        <span>{{ $t(markAllTitleHandler) }}</span>
      </div>
      <div class="oscillography-analysis__diagnostics-wrapper">
        <b-checkbox-group
          class="oscillography-analysis__checkbox-group p-3"
          v-model="selectedDiagnosticsProxy"
          text-field="name"
          value-field="id"
          stacked
          :options="diagnostics"
        />
      </div>
    </div>
  </b-container>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'OscillographyAnalysisTab',
  props: {
    selectedDiagnostics: {
      type: Array,
      default: () => ([]),
    },
    items: Object,
    loading: Boolean,
  },
  computed: {
    selectedDiagnosticsProxy: {
      get() {
        return this.selectedDiagnostics;
      },
      set(value) {
        this.$emit('update:selected-diagnostics', value);
      },
    },
    diagnostics() {
      return ((this.items || {}).norm || []).reduce(
        (all, norm) => all.concat(norm.diagnostics || []),
        [],
      );
    },
    showEmptyList() {
      return isEmpty(this.items) || !this.diagnostics.length;
    },
    markAllTitleHandler() {
      return this.allDiagnosticsToggled
        ? 'reports.diagnostics-history.unmark-all'
        : 'reports.diagnostics-history.mark-all';
    },
    allDiagnosticsToggled() {
      if (!this.diagnostics.length) {
        return false;
      }
      return this.diagnostics.every(
        diagnostic => this.selectedDiagnostics.includes(diagnostic.id),
      );
    },
  },
  methods: {
    toggleAllDiagnostics(event) {
      if (this.showEmptyList) {
        return;
      }
      if (event) {
        this.diagnostics.forEach(diagnostic => this.addSelectedItem(diagnostic.id));
        return;
      }
      this.diagnostics.forEach(diagnostic => this.removeSelectedItem(diagnostic.id));
    },
    addSelectedItem(selectedItem) {
      const itemExists = this.selectedDiagnostics.some(
        selectedDiagnostic => selectedDiagnostic === selectedItem,
      );
      if (itemExists) return;
      this.selectedDiagnosticsProxy.push(selectedItem);
    },
    removeSelectedItem(selectedItem) {
      const itemIndex = this.selectedDiagnostics.findIndex(
        selectedDiagnostic => selectedDiagnostic === selectedItem,
      );
      this.selectedDiagnosticsProxy.splice(itemIndex, 1);
    },
  },
};
</script>

<style scoped lang="sass">
  @import "src/styles/defaults/variables.sass"
  .oscillography-analysis
    &__diagnostics-wrapper
      border: 1px solid $color-border-gray
      border-radius: 5px
      max-height: 300px
      overflow-y: auto
      overflow-x: hidden
    &__checkbox-area
      display: flex
      flex-wrap: nowrap
      margin-bottom: 3px
    &__checkbox-group ::v-deep
      .custom-control.custom-checkbox
        margin-bottom: 5px
</style>
